import type { MechKey } from './keys';

export const pa: Partial<Record<MechKey, string>> = {
  'app.eyebrow': 'ਮਕੈਨਿਕਸ · 2D',
  'panel.scene': 'ਦ੍ਰਿਸ਼',
  'panel.dims': 'ਪੈਰਾਮੀਟਰ',
  'panel.style': 'ਦਿੱਖ',
  'panel.action': 'ਕੰਟਰੋਲ',
  'style.body': 'ਵਸਤੂ',
  'style.vector': 'ਸਦਿਸ਼',
  'style.ground': 'ਜ਼ਮੀਨ',
  'style.forces': 'ਬਲ ਦਿਖਾਓ',
  'style.trace': 'ਮਾਰਗ ਦਿਖਾਓ',
  'style.labels': 'ਸਦਿਸ਼ ਲੇਬਲ',
  'hint.line1': 'ਸ਼ੁਰੂ ਕਰਨ ਲਈ ਪਲੇਅ ਕਲਿੱਕ ਕਰੋ · ਵਸਤੂਆਂ ਨੂੰ ਖਿੱਚੋ',
  'hint.line2': 'ਸੈਂਡਬਾਕਸ: ਇੱਕ ਆਕਾਰ ਚੁਣੋ, ਫਿਰ ਰੱਖਣ ਲਈ ਕਲਿੱਕ ਕਰੋ',
  'scene.incline': 'ਝੁਕਿਆ ਤਲ',
  'scene.projectile': 'ਪ੍ਰੋਜੈਕਟਾਈਲ ਗਤੀ',
  'scene.pendulum': 'ਪੈਂਡੂਲਮ',
  'scene.springMass': 'ਸਪ੍ਰਿੰਗ-ਭਾਰ ਸਿਸਟਮ',
  'scene.collisions': 'ਟੱਕਰਾਂ',
  'scene.atwood': 'ਐਟਵੁੱਡ ਮਸ਼ੀਨ',
  'scene.circular': 'ਚੱਕਰਾਕਾਰ ਗਤੀ',
  'scene.sandbox': 'ਸੈਂਡਬਾਕਸ',
  'dim.angle': 'ਕੋਣ (°)',
  'dim.friction': 'ਰਗੜ',
  'dim.mass': 'ਭਾਰ',
  'dim.massA': 'ਭਾਰ A',
  'dim.massB': 'ਭਾਰ B',
  'dim.velocity': 'ਵੇਗ',
  'dim.angleLaunch': 'ਲਾਂਚ ਕੋਣ (°)',
  'dim.gravity': 'ਗੁਰੂਤਾ',
  'dim.gravityX': 'ਗੁਰੂਤਾ x',
  'dim.gravityY': 'ਗੁਰੂਤਾ y',
  'dim.length': 'ਲੰਬਾਈ',
  'dim.damping': 'ਡੈਂਪਿੰਗ',
  'dim.spring': 'ਕਠੋਰਤਾ',
  'dim.restitution': 'ਪ੍ਰਤਿਸਥਾਪਨ',
  'dim.radius': 'ਅਰਧ-ਵਿਆਸ',
  'dim.speed': 'ਚਾਲ',
  'action.play': 'ਚਲਾਓ',
  'action.pause': 'ਰੋਕੋ',
  'action.step': 'ਕਦਮ',
  'action.reset': 'ਰੀਸੈੱਟ',
  'action.speed': 'ਗਤੀ',
  'action.clear': 'ਸਾਫ਼ ਕਰੋ',
  'force.gravity': 'Fg',
  'force.normal': 'N',
  'force.friction': 'Ff',
  'force.tension': 'T',
  'force.spring': 'Fs',
  'force.applied': 'Fa',
  'force.air': 'Fd',
  'forceName.gravity': 'ਗੁਰੂਤਾ ਬਲ',
  'forceName.normal': 'ਲੰਬਵਤ ਬਲ',
  'forceName.friction': 'ਰਗੜ ਬਲ',
  'forceName.tension': 'ਖਿੱਚ',
  'forceName.spring': 'ਸਪ੍ਰਿੰਗ ਬਲ',
  'forceName.applied': 'ਲਾਗੂ ਕੀਤਾ ਬਲ',
  'forceName.air': 'ਹਵਾ ਪ੍ਰਤਿਰੋਧ',
  'palette.box': 'ਡੱਬਾ',
  'palette.circle': 'ਗੇਂਦ',
  'palette.ramp': 'ਢਲਾਨ',
  'palette.ground': 'ਜ਼ਮੀਨ',
  'palette.hint': 'ਇੱਕ ਆਕਾਰ ਚੁਣੋ, ਫਿਰ ਰੱਖਣ ਲਈ ਕੈਨਵਾਸ ਤੇ ਕਲਿੱਕ ਕਰੋ।',
  'panel.forces': 'ਦੇਖੇ ਗਏ ਬਲ',
  'forces.empty': 'ਹਾਲੇ ਕੁਝ ਨਹੀਂ — ਦ੍ਰਿਸ਼ ਚਲਾਓ',
};
